import { useContext } from "react";

import { AppConfigContext } from "../../../../core/configuration/Configuration";
import { useAuthorizedFetch } from "../../../../core/data-access/useAuthorizedFetch";
import { CreateEntityResponse } from "../../common/CreateEntityResponse";
import { CreateLanguageSpecificationRequest } from "./requests/CreateLanguageSpecificationRequest";
import { UpdateLanguageSpecificationRequest } from "./requests/UpdateLanguageSpecificationMappingRequest";
import { GetLanguageSpecificationByIdResponse } from "./responses/GetLanguageSpecificationByIdResponse";
import { GetLanguageSpecificationsListResponse } from "./responses/GetLanguageSpecificationsListResponse";
import { GetLanguageSpecificationsLookupResponse } from "./responses/GetLanguageSpecificationsLookupResponse";

export const useLanguageSpecificationApi = () => {
    const appConfigContext = useContext(AppConfigContext);
    const baseUrl = `${appConfigContext.ordersConfig.apiUrl}/language-specifications`;

    const { httpPost, httpGet, httpPut } = useAuthorizedFetch();

    const createLanguageSpecification = async (
        request: CreateLanguageSpecificationRequest
    ): Promise<CreateEntityResponse> => {
        return httpPost(`${baseUrl}/create`, request);
    };

    const getLanguageSpecificationsList = async (): Promise<GetLanguageSpecificationsListResponse> => {
        return httpGet<GetLanguageSpecificationsListResponse>(`${baseUrl}/get-list`);
    };

    const getLanguageSpecificationById = async (id: string): Promise<GetLanguageSpecificationByIdResponse> => {
        return httpGet<GetLanguageSpecificationByIdResponse>(`${baseUrl}/get-by-id`, { id });
    };

    const updateLanguageSpecificationMapping = async (request: UpdateLanguageSpecificationRequest): Promise<void> => {
        return httpPut<void>(`${baseUrl}/update`, request);
    };

    const getLanguageSpecificationsLookup = async (): Promise<GetLanguageSpecificationsLookupResponse> => {
        return httpGet<GetLanguageSpecificationsLookupResponse>(`${baseUrl}/get-lookup`);
    };

    return {
        createLanguageSpecification,
        getLanguageSpecificationsList,
        getLanguageSpecificationById,
        updateLanguageSpecificationMapping,
        getLanguageSpecificationsLookup
    };
};
